import { render, staticRenderFns } from "./sendPop.vue?vue&type=template&id=6f73b068&scoped=true&"
import script from "./sendPop.vue?vue&type=script&lang=js&"
export * from "./sendPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73b068",
  null
  
)

export default component.exports